import { render, staticRenderFns } from "./BaseLinkWithIcon.vue?vue&type=template&id=11957a62&scoped=true&"
import script from "./BaseLinkWithIcon.vue?vue&type=script&lang=js&"
export * from "./BaseLinkWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseLinkWithIcon.vue?vue&type=style&index=0&id=11957a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11957a62",
  null
  
)

export default component.exports